import Icon from '../components/Icon.vue'

Icon.register({"hotel":{"width":2048,"height":1792,"paths":[{"d":"M256 1024h1728q26 0 45 19t19 45v448h-256v-256h-1536v256h-256v-1216q0-26 19-45t45-19h128q26 0 45 19t19 45v704zM832 704q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM2048 960v-64q0-159-112.5-271.5t-271.5-112.5h-704q-26 0-45 19t-19 45v384h1152z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hotel.js
// module id = 643
// module chunks = 0